import AbstractClient from './AbstractClient'

class ProfileClient extends AbstractClient {
  changePassword (idazi, data) {
    return super.put(`/aziende/${idazi}/password`, data)
  }

  forgotPassword (data) {
    return super.post(`/users/reset-password`, data)
  }

  resetPassword (idazi) {
    return super.get(`/users/${idazi}/reset-password`)
  }
}

export default new ProfileClient()
